'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @since 2016-08-25 11:58
 * @author vivaxy
 */

var FETCH = exports.FETCH = 'FETCH';
var SERVER = exports.SERVER = 'SERVER';
var TIMEOUT = exports.TIMEOUT = 'TIMEOUT';
var AUTHORIZATION = exports.AUTHORIZATION = 'AUTHORIZATION';
var FORBIDDEN = exports.FORBIDDEN = 'FORBIDDEN';
var VALIDATION = exports.VALIDATION = 'VALIDATION';


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/configs/errors.js
// module id = 61
// module chunks = 0